import { t } from "i18next";
import { store } from "../../../../redux/store";
import {
    franchiseSelectionChanged,
    setNumberActive,
    setNumberArchived,
} from "../../../../redux/slices/fidelitySlice";

export function NumberActiveAndArchive(dataTable: FidelityDataTable) {
    if (
        dataTable.othersData !== undefined &&
        dataTable.othersData.activated !== undefined
    ) {
        store.dispatch(setNumberActive(dataTable.othersData.activated ?? 0));
        store.dispatch(setNumberArchived(dataTable.othersData.archived ?? 0));
    } else {
        store.dispatch(setNumberActive(0));
        store.dispatch(setNumberArchived(0));
    }
}
export function Selected(selectedRows: FidelityRow[], dataTable: FidelityDataTable, oneShop: boolean) {
    const localShop: string[] = [];
    const idsLocalShop: string[] = [];
    selectedRows.forEach((el) => {
        if (el[t("Shop")] !== "" && el[t("Shop")] !== undefined)
            localShop.push(el.shopId.toString());

        idsLocalShop.push(el.Id);
    });

    const selectedFidelity: Array<Record<string, string>> = [];
    Object.values(selectedRows).forEach((element) => {
        selectedFidelity.push({ [element.shopId]: element.Id });
    });

    const dataArchive = dataTable?.othersData?.listArchived ?? [];
    const dataActive = dataTable?.othersData?.dataDesignation ?? [];
    const dataFranchiseArchive = oneShop
        ? dataTable?.othersData?.allData?.othersData?.listArchived ?? []
        : dataTable?.othersData?.listArchived ?? [];

    store.dispatch(
        franchiseSelectionChanged({
            idsLocalShop,
            localShop,
            selectedFidelity,
            fidelityData: dataTable,
            dataArchive,
            dataActive,
            dataFranchiseArchive,
        })
    );
}
